import { BaseSecureDetails } from '../security/base-secure-details/base-secure-details';
import { Type, TemplateRef } from '@angular/core';
import { PermissionsInfo } from '../../../components/permissions-info';
import { TranslationSchema } from '../../../models/translations';
import { ModalButtonDescriptor } from '../models/modal-button-descriptor';
import { BaseSecureSearch } from '../security/base-secure-search/base-secure-search';
import { TcmSecureBaseComponent } from '../security/tcm-secure-base-component';
import { ComponentOptions } from '../models/modal-options';
import { FilePreviewModel } from '../models/file-preview-model';
import { FileResponse } from '../../../modules/tcm-core.module';
import { TranslationResolver } from '../../../helpers/translation-resolver';

export abstract class TcmModalService {    

    abstract closeActiveModal(data?: any);

    abstract closeModalByComponentRef(componentRef: any, data?: any);

    abstract openSecureComponentInModal<T = any>(
        component: Type<BaseSecureDetails<any, any>> | Type<BaseSecureSearch<any, any>> | Type<TcmSecureBaseComponent<any, any>>,
        componentOptions: ComponentOptions,
        size?: 'sm' | 'md' | 'lg',
        windowClass?: string): Promise<T>

    abstract openComponentInModal<T = any>(component: Type<any> | string, size?: 'sm' | 'md' | 'lg', componentOptions?: {}, windowClass?: string): Promise<T>;

    abstract showActionModalAsync<T>(
        title: ((schema: TranslationSchema) => string) | string,
        content: ((schema: TranslationSchema) => string) | TemplateRef<any> | string,
        size: 'sm' | 'md' | 'lg',
        buttons: ModalButtonDescriptor<T>[],
        templateData?: any): Promise<T>

    abstract showErrorModalAsync<T = void>(
        title: ((schema: TranslationSchema) => string) | string,
        content: ((schema: TranslationSchema) => string) | TemplateRef<any> | string,
        size?: 'sm' | 'md' | 'lg',
        buttons?: ModalButtonDescriptor<T>[],
        templateData?: any): Promise<T>

    abstract showSuccessModalAsync<T = void>(
        title: ((schema: TranslationSchema) => string) | string,
        content: ((schema: TranslationSchema) => string) | TemplateRef<any> | string,
        size?: 'sm' | 'md' | 'lg',
        buttons?: ModalButtonDescriptor<T>[],
        templateData?: any,
        dismissTimeout?: Promise<any>): Promise<T>;

    abstract showWarningModalAsync<T = void>(
        title: ((schema: TranslationSchema) => string) | string,
        content: ((schema: TranslationSchema) => string) | TemplateRef<any> | string,
        size?: 'sm' | 'md' | 'lg',
        buttons?: ModalButtonDescriptor<T>[],
        templateData?: any,
        windowClass?: string): Promise<T>;

    abstract showConfirmationModalAsync(
        title: ((schema: TranslationSchema) => string) | string,
        text: ((schema: TranslationSchema) => string) | TemplateRef<any> | string,
        confirmText?: ((schema: TranslationSchema) => string) | string,
        cancelText?: ((schema: TranslationSchema) => string) | string,
        templateData?: any): Promise<boolean>;

    abstract showFilePreviewAsync(model: FilePreviewModel | FileResponse, titleKey?: TranslationResolver) : Promise<any>;
}